import {
  FlexColumn,
  FlexRow,
  LabeledData,
  MaterialIcon,
  useElementWidth,
  useMoment,
} from '@gorila-shared-ui/components';
import { Badge } from 'baseui/badge';
import { Button } from 'baseui/button';
import { StyledDivider } from 'baseui/divider';
import { ParagraphMedium } from 'baseui/typography';
import { useRecoilValue, useResetRecoilState, useSetRecoilState } from 'recoil';
import { useStyles } from '../../../hooks/useStyles';
import { pathState, selectedPathIdState, updatePathState } from '../../../storage/reports';
import { BottomCard } from '../../../types/app';
import { formatDurationFromSeconds } from '../../../utils/dates';
import FloatingBottomCard from '../../layout/cards/FloatingBottomCard';
import { StyledTooltip } from '../../ui/StyledTooltip';

function PathInfo() {
  const { theme, classes } = useStyles();
  const path = useRecoilValue(pathState);
  const { formatDateFromTs } = useMoment();
  const { refCallback, elementWidth } = useElementWidth();
  const shouldShrink = elementWidth < 700;
  const defaultLabelWidth = '210px';
  const resetSelectedPathId = useResetRecoilState(selectedPathIdState);
  const setUpdatePath = useSetRecoilState(updatePathState);

  if (!path) {
    return null;
  }
  const startText =
    path.startDate && path.startGeoreference
      ? `${formatDateFromTs(path.startDate)} en ${path.startGeoreference}`
      : path.startDate
        ? `${formatDateFromTs(path.startDate)}`
        : undefined;
  const endText =
    path.endDate && path.endGeoreference
      ? `${formatDateFromTs(path.endDate)} en ${path.endGeoreference}`
      : path.endDate
        ? `${formatDateFromTs(path.endDate)}`
        : undefined;

  const onClose = () => {
    resetSelectedPathId();
  };

  const onReload = () => {
    setUpdatePath((prev) => !prev);
  };

  return (
    <FloatingBottomCard
      padding="0"
      name={BottomCard.pathInfo}
    >
      <FlexColumn
        gap={0}
        ref={refCallback}
      >
        <FlexRow
          classNames={classes.centeredBetween}
          padding={`${theme.sizing.scale300} ${theme.sizing.scale600}`}
        >
          <FlexRow
            centered
            gap={theme.sizing.scale300}
          >
            <ParagraphMedium
              margin={0}
              style={{ fontWeight: '700', fontSize: '18px' }}
            >
              Información del trayecto
            </ParagraphMedium>
            {path.active && (
              <Badge
                content="Activo"
                shape="rectangle"
                color="positive"
                overrides={{
                  Badge: {
                    style: {
                      fontSize: '12px',
                      padding: `${theme.sizing.scale0} ${theme.sizing.scale300}`,
                    },
                  },
                }}
              />
            )}
          </FlexRow>
          <FlexRow gap={theme.sizing.scale200}>
            {path.active && (
              <StyledTooltip
                content="Recargar"
                placement="top"
                showArrow={false}
              >
                <Button
                  shape="circle"
                  kind="tertiary"
                  size="mini"
                  onClick={onReload}
                >
                  <MaterialIcon
                    name="refresh"
                    size="16px"
                  />
                </Button>
              </StyledTooltip>
            )}
            <StyledTooltip
              content="Cerrar trayecto"
              placement="top"
              showArrow={false}
            >
              <Button
                shape="circle"
                kind="tertiary"
                size="mini"
                onClick={onClose}
              >
                <MaterialIcon
                  name="close"
                  size="16px"
                />
              </Button>
            </StyledTooltip>
          </FlexRow>
        </FlexRow>
        <StyledDivider style={{ margin: 0, width: '100%' }} />
        <FlexColumn
          gap={theme.sizing.scale0}
          padding={`${theme.sizing.scale500} ${theme.sizing.scale600}`}
        >
          <LabeledData
            label="Inicio:"
            content={startText || '-'}
            inline={false}
            maxLines={2}
            labelWidth={shouldShrink ? '40px' : defaultLabelWidth}
          />
          <LabeledData
            label="Fin:"
            content={endText || '-'}
            inline={false}
            maxLines={2}
            labelWidth={shouldShrink ? '40px' : defaultLabelWidth}
          />
          <LabeledData
            label="Distancia recorrida:"
            content={`${path.distanceKms?.toFixed(2)} Km`}
            labelWidth={shouldShrink ? undefined : defaultLabelWidth}
          />
          <LabeledData
            label="Duración:"
            content={formatDurationFromSeconds(path.totalSeconds)}
            labelWidth={shouldShrink ? '60px' : defaultLabelWidth}
          />
          <LabeledData
            label="Número de posiciones:"
            content={path.totalPositions?.toString() || '-'}
            labelWidth={shouldShrink ? undefined : defaultLabelWidth}
          />
          <LabeledData
            label="Número de eventos en ralenty:"
            content={path.totalRalenty?.toString() || '-'}
            labelWidth={shouldShrink ? undefined : defaultLabelWidth}
          />
        </FlexColumn>
      </FlexColumn>
    </FloatingBottomCard>
  );
}

export default PathInfo;
